import React, { createContext, useState, useContext, useEffect } from 'react';
import { getSwitchStateFromDB } from '../services/idbService';


const OfflineSwitchContext = createContext();

export const useOfflineSwitch = () => useContext(OfflineSwitchContext);

export const OfflineSwitchProvider = ({ children }) => {
    const [offlineSwitchState, setOfflineSwitchState] = useState(true);

    useEffect(() => {
        async function fetchSwitchState() {
            const username = localStorage.getItem('currentUser') || 'unknown';
            try {
                const newState = await getSwitchStateFromDB("user_switch_state", username);
                setOfflineSwitchState(newState !== undefined ? newState : true);
            } catch (error) {
                console.error('Error fetching switch state:', error);
                // Default to true in case of error
                setOfflineSwitchState(true);
            }
        }

        fetchSwitchState();
    }, []);

    return (
        <OfflineSwitchContext.Provider value={{ offlineSwitchState, setOfflineSwitchState }}>
            {children}
        </OfflineSwitchContext.Provider>
    );
};
